[
  {
    "id": "TB-B7-001",
    "module": "Taalbegrip",
    "difficulty": 201,
    "question": "Tik op het woord waar 'hij' naar verwijst.",
    "options": ["De wolf"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "De wolf", "id": "s1", "isCorrect": true },
        { "text": " was vroeger een gevreesd dier in Nederland. ", "id": "s2", "isTappable": false },
        { "text": "Mensen", "id": "s3" },
        { "text": " waren bang voor hem. Sinds 2015 is ", "id": "s4", "isTappable": false },
        { "text": "hij", "id": "s5", "isHighlighted": true, "isTappable": false },
        { "text": " terug. ", "id": "s6", "isTappable": false },
        { "text": "Natuurbeschermers", "id": "s7" },
        { "text": " zijn blij, maar ", "id": "s8", "isTappable": false },
        { "text": "boeren", "id": "s9" },
        { "text": " maken zich zorgen.", "id": "s10", "isTappable": false }
      ],
      "feedbackMap": {
        "s1": "Goed! 'Hij' verwijst terug naar 'de wolf'.",
        "s3": "Mensen is meervoud ('zij'), niet 'hij'.",
        "s7": "Natuurbeschermers is meervoud.",
        "s9": "Boeren is meervoud."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-WOLF",
    "explanation": "Het woord 'hij' verwijst terug naar 'de wolf' uit de eerste zin. De wolf is terug in Nederland.",
    "distractorExplanations": {
      "2": "Mensen is meervoud ('zij'), niet 'hij'.",
      "6": "Natuurbeschermers is meervoud.",
      "8": "Boeren is meervoud."
    }
  },
  {
    "id": "TB-B7-002",
    "module": "Taalbegrip",
    "difficulty": 201,
    "question": "Tik op het signaalwoord in de tekst.",
    "options": ["Bovendien"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "Veel kinderen eten te weinig groente. ", "id": "s1", "isTappable": false },
        { "text": "Bovendien", "id": "s2", "isCorrect": true },
        { "text": " bewegen ze te weinig. ", "id": "s3", "isTappable": false },
        { "text": "Hierdoor", "id": "s4" },
        { "text": " worden steeds meer kinderen te zwaar.", "id": "s5", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "Goed! 'Bovendien' is een opsommend signaalwoord.",
        "s4": "'Hierdoor' is ook een signaalwoord (oorzaak-gevolg), maar de vraag zoekt het opsommende signaalwoord."
      }
    },
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-BOVENDIEN",
    "explanation": "'Bovendien' is een opsommend signaalwoord. Het betekent: er komt nog iets bij. Eerst te weinig groente, en daarnaast ook te weinig bewegen.",
    "distractorExplanations": {
      "3": "'Hierdoor' geeft een gevolg aan, geen opsomming."
    }
  },
  {
    "id": "TB-B7-003",
    "module": "Taalbegrip",
    "difficulty": 201,
    "question": "Tik op het woord waar 'ze' naar verwijst.",
    "options": ["Dolfijnen"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "Dolfijnen", "id": "s1", "isCorrect": true },
        { "text": " zijn intelligente dieren. ", "id": "s2", "isTappable": false },
        { "text": "Ze", "id": "s3", "isHighlighted": true, "isTappable": false },
        { "text": " leven in ", "id": "s4", "isTappable": false },
        { "text": "groepen", "id": "s5" },
        { "text": " en communiceren met ", "id": "s6", "isTappable": false },
        { "text": "klikgeluiden", "id": "s7" },
        { "text": ". ", "id": "s8", "isTappable": false },
        { "text": "Onderzoekers", "id": "s9" },
        { "text": " ontdekten dat elke dolfijn een eigen 'naam' heeft.", "id": "s10", "isTappable": false }
      ],
      "feedbackMap": {
        "s1": "Goed! 'Ze' verwijst naar de dolfijnen.",
        "s5": "Groepen is waar ze in leven, niet wie ze zijn.",
        "s7": "Klikgeluiden is waarmee ze communiceren.",
        "s9": "Onderzoekers worden pas later genoemd."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-DOLFIJNEN",
    "explanation": "'Ze' verwijst terug naar 'dolfijnen' in de eerste zin. Dolfijnen leven in groepen.",
    "distractorExplanations": {
      "4": "Groepen is waar ze in leven, niet wie ze zijn.",
      "6": "Klikgeluiden is waarmee ze communiceren.",
      "8": "Onderzoekers worden pas later genoemd."
    }
  },
  {
    "id": "TB-B7-004",
    "module": "Taalbegrip",
    "difficulty": 201,
    "question": "Lees de tekst:\n\n\"Robots worden steeds slimmer. Toch kunnen ze nog niet alles wat mensen kunnen. Bijvoorbeeld: een robot kan niet echt voelen of creatief denken.\"\n\nHet woord 'toch' is een signaalwoord. Wat voor soort verband legt het?",
    "options": ["Een tegenstelling", "Een opsomming", "Een oorzaak", "Een tijdsvolgorde"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-TOCH",
    "explanation": "'Toch' geeft een tegenstelling aan. Robots worden slimmer, MAAR (toch) ze kunnen nog niet alles.",
    "distractorExplanations": {
      "1": "Een opsomming zou 'ook' of 'bovendien' zijn.",
      "2": "Een oorzaak zou 'doordat' of 'want' zijn.",
      "3": "Een tijdsvolgorde zou 'daarna' of 'vervolgens' zijn."
    }
  },
  {
    "id": "TB-B7-005",
    "module": "Taalbegrip",
    "difficulty": 201,
    "question": "Lees de tekst:\n\n\"De Olympische Spelen worden elke vier jaar gehouden. Atleten uit de hele wereld doen mee. De eerste moderne Spelen waren in 1896 in Athene.\"\n\nWat is de hoofdgedachte van deze tekst?",
    "options": ["De Olympische Spelen zijn een groot sportevenement dat elke vier jaar plaatsvindt", "Athene is een mooie stad", "Atleten trainen heel hard", "1896 was een belangrijk jaar"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "hoofdgedachte",
    "familyId": "TB-OLYMPISCH",
    "explanation": "De tekst geeft basisinformatie over de Olympische Spelen: hoe vaak, wie doet mee, en wanneer het begon.",
    "distractorExplanations": {
      "1": "Athene wordt alleen als locatie genoemd.",
      "2": "Training wordt niet besproken in de tekst.",
      "3": "1896 is een detail, niet de hoofdgedachte."
    }
  },
  {
    "id": "TB-B7-006",
    "module": "Taalbegrip",
    "difficulty": 201,
    "question": "Tik op het stuk tekst waar 'daarbij' naar verwijst.",
    "options": ["echolocatie om in het donker te navigeren"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "Vleermuizen", "id": "s1" },
        { "text": " zijn de enige zoogdieren die kunnen ", "id": "s2", "isTappable": false },
        { "text": "vliegen", "id": "s3" },
        { "text": ". Ze gebruiken ", "id": "s4", "isTappable": false },
        { "text": "echolocatie om in het donker te navigeren", "id": "s5", "isCorrect": true },
        { "text": ". ", "id": "s6", "isTappable": false },
        { "text": "Daarbij", "id": "s7", "isHighlighted": true, "isTappable": false },
        { "text": " stoten ze geluidsgolven uit en luisteren naar de echo.", "id": "s8", "isTappable": false }
      ],
      "feedbackMap": {
        "s1": "Vleermuizen is het onderwerp, maar 'daarbij' verwijst naar een activiteit.",
        "s3": "Vliegen wordt in de eerste zin genoemd, maar 'daarbij' verwijst naar de tweede zin.",
        "s5": "Goed! 'Daarbij' verwijst naar echolocatie/navigeren. Het legt uit HOE dat werkt."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-VLEERMUIS",
    "explanation": "'Daarbij' verwijst naar echolocatie/navigeren uit de vorige zin. Het legt uit HOE echolocatie werkt.",
    "distractorExplanations": {
      "0": "Vleermuizen is het onderwerp, niet de activiteit waar 'daarbij' naar verwijst.",
      "2": "Vliegen wordt in de eerste zin genoemd, maar 'daarbij' verwijst naar de tweede zin."
    }
  },
  {
    "id": "TB-B7-007",
    "module": "Taalbegrip",
    "difficulty": 201,
    "question": "Welk signaalwoord past het best?\n\n\"Het was koud buiten. ... trok Lisa haar dikke jas aan.\"",
    "options": ["Daarom", "Maar", "Hoewel", "Bovendien"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-INVUL",
    "explanation": "'Daarom' geeft een oorzaak-gevolg verband aan. Het was koud (oorzaak), daarom trok ze haar jas aan (gevolg).",
    "distractorExplanations": {
      "1": "'Maar' geeft een tegenstelling aan. Hier is geen tegenstelling.",
      "2": "'Hoewel' geeft een tegenstelling aan (ondanks dat).",
      "3": "'Bovendien' voegt iets toe, maar hier is sprake van oorzaak-gevolg."
    }
  },
  {
    "id": "TB-B7-008",
    "module": "Taalbegrip",
    "difficulty": 201,
    "question": "Tik op het stuk tekst waar 'dat' naar verwijst in de tweede zin.",
    "options": ["dat er leven op Mars kan zijn"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "Sommige ", "id": "s1", "isTappable": false },
        { "text": "wetenschappers", "id": "s2" },
        { "text": " denken dat ", "id": "s3", "isTappable": false },
        { "text": "er leven op Mars kan zijn", "id": "s4", "isCorrect": true },
        { "text": ". Anderen geloven ", "id": "s5", "isTappable": false },
        { "text": "dat", "id": "s6", "isHighlighted": true, "isTappable": false },
        { "text": " niet. ", "id": "s7", "isTappable": false },
        { "text": "Het debat", "id": "s8" },
        { "text": " gaat al jaren door.", "id": "s9", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "Wetenschappers is wie het denkt, niet wat 'dat' naar verwijst.",
        "s4": "Goed! 'Dat' verwijst naar de bewering: dat er leven op Mars kan zijn.",
        "s8": "Het debat wordt pas in de derde zin genoemd."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-MARS",
    "explanation": "'Dat' verwijst naar de bewering uit de eerste zin: dat er leven op Mars kan zijn. Anderen geloven dat (= die bewering) niet.",
    "distractorExplanations": {
      "1": "Wetenschappers is wie het denkt, niet wat 'dat' naar verwijst.",
      "7": "Het debat wordt pas in de derde zin genoemd."
    }
  },
  {
    "id": "TB-B7-009",
    "module": "Taalbegrip",
    "difficulty": 201,
    "question": "Lees de tekst:\n\n\"Nederland is een klein land, maar het heeft een grote invloed op de wereldhandel. De haven van Rotterdam is een van de grootste ter wereld. Daarnaast exporteert Nederland veel landbouwproducten.\"\n\nWat voor signaalwoord is 'daarnaast'?",
    "options": ["Opsomming (er komt iets bij)", "Tegenstelling", "Oorzaak-gevolg", "Tijdsvolgorde"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-DAARNAAST",
    "explanation": "'Daarnaast' is een opsommend signaalwoord. Het voegt een extra punt toe: naast de haven, ook landbouwexport.",
    "distractorExplanations": {
      "1": "Een tegenstelling zou 'echter' of 'maar' zijn.",
      "2": "Er is geen oorzaak-gevolg relatie hier.",
      "3": "Er is geen tijdsvolgorde hier."
    }
  },
  {
    "id": "TB-B7-010",
    "module": "Taalbegrip",
    "difficulty": 201,
    "question": "Tik op het stuk tekst waar 'dit' naar verwijst.",
    "options": ["De zeespiegel stijgt"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "De zeespiegel stijgt", "id": "s1", "isCorrect": true },
        { "text": " door ", "id": "s2", "isTappable": false },
        { "text": "klimaatverandering", "id": "s3" },
        { "text": ". ", "id": "s4", "isTappable": false },
        { "text": "Dit", "id": "s5", "isHighlighted": true, "isTappable": false },
        { "text": " is vooral gevaarlijk voor laaggelegen landen zoals ", "id": "s6", "isTappable": false },
        { "text": "Nederland", "id": "s7" },
        { "text": ". Er worden ", "id": "s8", "isTappable": false },
        { "text": "dijken", "id": "s9" },
        { "text": " verhoogd om het water tegen te houden.", "id": "s10", "isTappable": false }
      ],
      "feedbackMap": {
        "s1": "Goed! 'Dit' verwijst naar het stijgen van de zeespiegel.",
        "s3": "Klimaatverandering is de oorzaak, maar 'dit' verwijst naar het gevolg (de stijging).",
        "s7": "Nederland is een voorbeeld, niet waar 'dit' naar verwijst.",
        "s9": "Dijken worden pas in de derde zin genoemd."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-ZEESPIEGEL",
    "explanation": "'Dit' verwijst naar het stijgen van de zeespiegel. Dat stijgen is gevaarlijk voor laaggelegen landen.",
    "distractorExplanations": {
      "2": "Klimaatverandering is de oorzaak, maar 'dit' verwijst naar het gevolg (de stijging).",
      "6": "Nederland is een voorbeeld, niet waar 'dit' naar verwijst.",
      "8": "Dijken worden pas in de derde zin genoemd."
    }
  }
]